<!-- Universal Icon Conponent -->

<template>
	<div class="uni-ico-main" :style="{padding:pad+'px'}">
		<div
			:id="div_id" 
			class="ico_fit"
			v-html="content" 
			:data-ico="ico" 
			:data-color="color"
			:data-fit="fit"
			:data-size="w+'x'+h"
			>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		w:		{default:'64'},
		h:		{default:'64'},
		pad:	{default:'2'},
		fit:	{default:'0'},
		ico:	{default:'asterisk'},
		color:	{default:'#000'},
	},
	data() {
		return {
			div_id: this.genWord(10),
			content: null,
		};
	},
	methods: {
		// Generate Random Word ==========
		genWord(word_len) {
			var pool = "abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ0123456789"; // skip 'IlOo'
			var word = "";
			for (var i=0; i<word_len; i++) {
				var idx = Math.floor(Math.random() * (pool.length+1) );
				word += pool.substr(idx, 1);
			}
			return word;
		},
		setImage() {
			let new_content = null;
			try {
				new_content = require('@/assets/ico/' + this.ico + '.svg');
			} catch {
				new_content = require('@/assets/ico/asterisk.svg');
			}
			this.content = new_content.default;
		},
		setColor() {
			var obj = document.getElementById(this.div_id);
			obj.style.fill = this.color;
		},
		setSize() {
			const ico_div = document.getElementById(this.div_id);
			const wrapper = ico_div.parentElement;
			if (this.fit=='1') {
				wrapper.style.width="100%";
				wrapper.style.height="100%";
			} else {
				wrapper.style.width=this.w+"px";
				wrapper.style.height=this.h+"px";
			}

			const svgs = ico_div.getElementsByTagName("svg");
			if (svgs.length>0) {
				// svgs[0].setAttribute("viewBox", "0 0 100 100");
				svgs[0].setAttribute("width", "100%");
				svgs[0].setAttribute("height", "100%");
			}

	},
		setColorParts() {
			var ico_div = document.getElementById(this.div_id);
			var tag_names = ('path,rect,circle,ellipse,line,polyline,polygon');
			var nodes = ico_div.querySelectorAll(tag_names);
			for (var i=0; i<nodes.length; i++) {
				nodes[i].style.fill = this.color;
				// nodes[i].style.stroke = this.color;
			}
		}
	},
	created() {
	},
	mounted() {
		this.setImage();
	},
	updated() {
		this.setImage();
		this.setColor();
		this.setSize();
	}
}
</script>

<style scoped>
.uni-ico-main {
	display: inline-block;
	/* width: 96px;
	height: 96px; */
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #C30;
}
.ico_fit {
		/* width: calc(100% - 8px); */
		/* height: calc(100% - 8px); */
		/* display:inline-block; */
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: relative;
    	top: 50%;
    	left: 50%;
		pointer-events: none;
		-webkit-transform: translateX(-50%) translateY(-50%);
		-moz-transform: translateX(-50%) translateY(-50%);
		-ms-transform: translateX(-50%) translateY(-50%);
		-o-transform: translateX(-50%) translateY(-50%);
		transform: translateX(-50%) translateY(-50%);
		border: solid 0px #090;
}

</style>
